/*
    Slightly tweaked modulus operation to work with negative numbers
    For instance: A value of -2 for a length of 10 will return 8

    @author Christian de Wit
    @version 1.0.0
*/
export default function modulo(value, length) {
    return ((value % length) + length) % length;
    // can also be expressed as:
    // value - length * Math.floor(value / length);
}
